import { HTTP } from "../helpers/http-common.js";
import authHeader from "../helpers/auth-header";
import helpers from "../helpers/helpers";

const closeBoxesService = {
    getInvoicesAmount,
    getCloseBoxes,
    storeCloseBox,
    updateCloseBox,
    getCloseBox,
    deleteCloseBox
};

export default closeBoxesService;

//Get report invoices
function getInvoicesAmount(page, search = {}) {
  let params = "";
  if (search.term) {
    params += `&search=${search.term}`;
  }

  if (search.options) {
    params += `&options=${search.options}`;
  }

  if (search.rangeDates) {
    params += `&range_dates=${search.rangeDates}`;
  }

  return HTTP.get(`invoices-amount?page=${page}${params}`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function getCloseBoxes(page = 0, search = {}) {

  let params = '';
  
  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if (search.rangeDates) {
    params += `&range_dates=${search.rangeDates}`;
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`close-boxes?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getCloseBox(id) {
  return HTTP.get(`close-box/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storeCloseBox(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-close-box',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updateCloseBox(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-close-box',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deleteCloseBox(id) {
  return HTTP({
    method: 'post',
    url: 'delete-close-box',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}